module.exports = __webpack_public_path__ + "static/media/theme.1a84f8ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/components/loader-generating/icons/theme.png
// module id = 1134
// module chunks = 0